import React from 'react'
import { AppBar, Toolbar, IconButton, Box, Divider } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { makeStyles } from '@material-ui/styles'
import { AccountMenu } from './components'
import { mutualTheme } from '~/utils/theme'
import { getSidebarWidth } from '~/utils/themeHelpers'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: mutualTheme.topbar.height
  },
  divider: {
    height: 35,
    alignSelf: 'center',
    marginRight: mutualTheme.spacing(2),
    marginLeft: mutualTheme.spacing(2)
  },
  appbar: {
    boxShadow: mutualTheme.boxShadow.container,
    width: `calc(100% - ${getSidebarWidth()}px)`,
    marginLeft: getSidebarWidth(),
    backgroundColor: mutualTheme.topbar.backgroundColor
  },
  buttonsContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between'
  },
  labeledButton: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: mutualTheme.spacing(2)
  },
  labeledButtonText: {
    marginLeft: mutualTheme.spacing(1)
  }
})

export type NavbarProps = {
  toggleSidebar: () => void
}

export const Navbar: React.FC<NavbarProps> = (props) => {
  const { toggleSidebar } = props
  const classes = useStyles()

  return (
    <AppBar position='sticky' className={classes.appbar} elevation={0}>
      <Toolbar className={classes.toolbar}>
        <Box className={classes.buttonsContainer}>
          <IconButton edge='start' onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>
        </Box>

        <Box style={{ display: 'flex' }}>
          <Divider className={classes.divider} orientation='vertical' />
          <AccountMenu />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
